<!--
 * @Author: your name
 * @Date: 2022-03-09 09:57:20
 * @LastEditTime: 2023-05-10 13:54:49
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202204/components/gotomini2.vue
-->
<template>
  <div style="text-align: center; position: relative;z-index:10;">
    <wx-open-launch-weapp
      v-if="isBrowser()"
      id="launch-btn"
      username="gh_c5b4fc3fafc9"
      path="/activityPage/pages/bigactivityDetail"
    >
      <script type="text/wxtag-template">
        <span v-if="isBrowser()" style="display: block;width:100vw;height:108px;position:relative;z-index:20;">

        </span>
      </script>
    </wx-open-launch-weapp>
    <span
      v-if="!isBrowser()"
      style="display: block; width: 100%; height: 108px;position:relative;z-index:20;"
      @click="gotomini"
    >
    </span>
  </div>
</template>

<script>
import loginDialog from "../components/dialog/login/index";
import maidian from '@/utils/maidian'
export default {
  mounted() {
    try {
      var btn = document.getElementById("launch-btn");
      btn.addEventListener("launch", (e) => {
        this.addTime();
      });
    } catch (error) {
      console.log("error", error);

      var btn = document.getElementById("launch-btn");
      btn.addEventListener("error", (e) => {
        console.log("fail", e.detail);
      });
    }
  },
  methods: {
    addTime(callback) {
      maidian.eventBind('mini');
      // this.$axios
      //   .get("/changmatwo/addnum?source=xcx", {
      //     source: "xcx",
      //   })
      //   .then((res) => {
      //     if (res.code == 400) {
      //       loginDialog({
      //         callback: () => {
      //           this.$axios.get("/changmatwo/getchannelnum").then((res) => {
      //             this.addTime(callback);
      //           });
      //         },
      //       });
      //     } else {
      //       this.$emit("startNum");
      //       callback && callback();
      //     }
      //   });
    },
    gotomini() {
      this.addTime(() => {});
      if (this.isBrowser()) {
        console.log("isBrowser", this.isBrowser());
        return false;
      }
      console.log("window.hysdk.sniff.scheme", window.hysdk.sniff.scheme);

      location.href =
        window.hysdk.sniff.scheme +
        "://miniprogram/launchMiniProgram?userName=gh_c5b4fc3fafc9&path=/activityPage/pages/bigactivityDetail";
    },
    isBrowser() {
      if (window.hysdk.sniff.scheme) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less" scoped="true">
.jumpToMini {
  margin-top: 14px;
  width: 256px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 47px;
  display: inline-block;
}
#launch-btn {
  width: 315px;
  height: 115px;
}
</style>